import { HttpClient } from '../../apiCalls/httpClient'

export const deleteMerchandise = (merchandiseId) => {
  let dataSent = {
    eventType: 'DELETE_B3_ENTITY',
    eventTime: Date.now(),
    eventMessage: {
      shipmentId: window.shipmentId,
      descriptionOfMerchandise: {
        merchandiseLineItems: [
          {
            merchandiseId: merchandiseId
          }
        ]
      }
    }
  }
  return HttpClient.post(dataSent)
    .catch(error => {
      console.error(`Error from axios on FIELD delete: `, error)
    })
}

export const deleteNotesItem = (noteId) => {
  let dataSent = {
      eventType: "DELETE_SHIPMENT_NOTES",
      eventTime: Date.now(),
      eventMessage: 
              {
                  shipmentId: window.shipmentId,
                  noteId
              }
          
      
      };

  return HttpClient.post(dataSent)
      .catch(error => {
          console.error(`Error from axios on FIELD delete: `, error)
      })

}

export const deleteInvoice = (invoiceId, invoiceIndex, updateStatus) => {
  let dataSent = {
    eventType: 'DELETE_B3_ENTITY',
    eventTime: Date.now(),
    eventMessage: {
      shipmentId: window.shipmentId,
      descriptionOfInvoice: {
        invoices: [{
          invoiceId
        }]
      }
    }
  }
  return HttpClient.post(dataSent)
    .catch(error => {
      console.error(`Error deleting invoice: `, error)
    })
}

export const deleteContainer = number => {
  let dataSent = {
    eventType: 'DELETE_B3_ENTITY',
    eventTime: Date.now(),
    eventMessage: {
      bolInfo: {
        container: [
          {
            number: number
          }
        ]
      }
    }
  }
  HttpClient.post(dataSent)
    .catch(error => {
      console.error(`Error from axios on FIELD delete: `, error)
    })
}

export const deletePGAItems = (pgaItems, merchandiseId, formType = 1) => {
  let dataSent = {
    eventType: 'DELETE_B3_ENTITY',
    eventTime: Date.now(),
    eventMessage: {
      shipmentId: window.shipmentId,
      merchandiseId,
      formType,
      pgaItems
    }
  }
  HttpClient.post(dataSent)
    .catch(error => {
      console.error(`Error DELETE_B3_ENTITY`, error)
    })
}

export const deletePgaFormData = (formType, merchandiseId, shipmentId) => {
  let dataSent = {
    eventMessage: {
      shipmentId: shipmentId,
      merchandiseId: merchandiseId,
      formType: formType
    },
    eventType: "DELETE_B3_ENTITY",
    eventTime: 1539730411376
  }
  HttpClient.post(dataSent)
    .catch(error => {
      console.error(`Error DELETE_B3_ENTITY`, error)
    })
}